import { RedemptionTypesUuids } from 'embed/actions'
import { CommonState } from 'embed/reducers'
import { LoanPurposeOptions, Product, VehicleIdTypeOptions } from '@evenfinancial/even-ts-static'
import { createSelector } from 'reselect'

const filtersSelector = (state: CommonState) => state.filters
export const filtersLoanSelector = (state: CommonState) => filtersSelector(state)?.loan
export const filtersProductSelector = (state: CommonState, product: Product) => state.filters[product]
export const filtersLoanCreditScoreSelector = (state: CommonState): string | undefined =>
  filtersLoanSelector(state)?.providedCreditRating
export const filtersLoanPurposeSelector = (state: CommonState): LoanPurposeOptions | undefined =>
  filtersLoanSelector(state)?.purpose
export const filtersLoanLenderIdSelector = (state: CommonState) => filtersLoanSelector(state)?.lenderId
export const filtersLoanVehicleIdTypeSelector = (state: CommonState): VehicleIdTypeOptions | undefined =>
  filtersLoanSelector(state)?.vehicleIdType
export const filtersCreditCardSelector = (state: CommonState) => filtersSelector(state).credit_card
export const filtersCreditCardCreditScoreSelector = (state: CommonState): string | undefined =>
  filtersCreditCardSelector(state)?.providedCreditRating
export const filtersCreditCardPurposesSelector = (state: CommonState) => filtersCreditCardSelector(state)?.cardPurposes
export const filtersCreditRedemptionTypesSelector = (state: CommonState): RedemptionTypesUuids =>
  filtersCreditCardSelector(state)?.redemptionTypes || []
export const filtersCreditSpendingCalculatorSelector = (state: CommonState) =>
  filtersCreditCardSelector(state)?.spendingCalculator
export const filtersCreditAnnualIncomeSelector = (state: CommonState) => {
  const annualIncomeString = filtersCreditCardSelector(state)?.annualIncome
  return annualIncomeString !== undefined ? parseFloat(annualIncomeString.replace(/[^0-9.]/g, '')) : undefined
}
export const filtersVehicleIdTypeSelector = (state: CommonState) => filtersLoanSelector(state)?.vehicleIdType
export const filtersCreditRewardsPreferenceSelector = (state: CommonState) =>
  filtersCreditCardSelector(state)?.rewardsPreference
// TODO make Offer augmenter return enums
export const filtersCreditCardRewardsPreferenceUuidSelector = createSelector(
  [filtersCreditRewardsPreferenceSelector, filtersCreditRedemptionTypesSelector],
  (rewardsPreference?: string, redemptionTypes?) => {
    if (rewardsPreference && redemptionTypes?.hasOwnProperty(rewardsPreference)) {
      return redemptionTypes[rewardsPreference]
    }
    return undefined
  },
)
export const filtersLifeInsuranceSelector = (state: CommonState) => filtersSelector(state).life_insurance
export const filtersLifeInsuranceDobSelector = (state: CommonState) => filtersLifeInsuranceSelector(state)?.dateOfBirth
export const filtersLifeInsuranceStateSelector = (state: CommonState): string | undefined =>
  filtersLifeInsuranceSelector(state)?.state
